// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"0ab76b9d","148":"4af5ca9e","715":"f335cf3a","718":"07e9d1cf","896":"85fcd250"}[chunkId] + ".chunk.js";
};